import { useStarterDashboardV2PageFcm } from 'src/app/pages/starterDashboardV2/pageContext';

type UsePetitionOverviewReturn = ModelHookResult<{
	strengthTipsEnabled: boolean;
}>;

export function usePetitionOverview(): UsePetitionOverviewReturn {
	const { strengthTipsEnabled } = useStarterDashboardV2PageFcm();

	return {
		data: {
			strengthTipsEnabled,
		},
	};
}
